module.exports = __webpack_public_path__ + "static/go_inside-360c25845d6c6b5b7ddd7df1911d3ec8.jpg";